import React, { useState, useEffect, useRef } from "react";
import CustomModal from "../../components/CustomModal";
import Button from "react-bootstrap/Button";
import InfoIconRed from "../../images/InfoIconRed.svg";
import "./RevertBackSmartTemp.scss";
import { updatSlideData } from "../../services/apis";

const ReferenceWarning = ({
  referenceBetween,
  editor,
  //currentSlide,
  setReferenceBetween,
  setAddReferenceBlock,
  addReferenceBlock
}) => {

  const modularSequence = ["A", "B", "C", "D", "E", "F", "G"];
  let referenceIndex = 0;
  const modBlockLength = editor
    ?.getWrapper()
    .find("[modularBlock]");
  //get refrenceBlock id
  for (var i = 0; i < modBlockLength.length; i++) {
    const index = modBlockLength[i].getAttributes();
    if (index.hasOwnProperty("modularBlock") && index["modularBlock"] === "reference") {
      referenceIndex = i;

    }
  }

  const current = editor.getSelected();
  const handleReferenceBetween = () => {
    for (var i = 0; i < modBlockLength.length; i++) {
      const index = modBlockLength[i].getAttributes();
      if (index.hasOwnProperty("modularBlock") && i > referenceIndex) {
        //  toastMsg("success", "Approved content below reference has been removed.");
        const existLabel = modBlockLength[i].getLastChild();
        if (existLabel.attributes.name !== "Cell") {
          existLabel.remove();
        }
        const hasAttr = modBlockLength[i].getAttributes();
        if (hasAttr.hasOwnProperty("modularBlock")) {
          modBlockLength[i].removeAttributes(["modularBlock", "modularBlockIndex"]);
        }
        // hideOptions();
        const retainCell = modBlockLength[i].getLastChild();
        retainCell.setStyle({ display: "block" });
        modBlockLength[i].setStyle({
          // "background-color": "#fff",
          "background-image": "none",
          border: "none",
        });
        modBlockLength[i].set({
          selectable: true,
          removable: true,
          draggable: true,
          copyable: true,
          resizable: true
        });
      }
    }
    current.addAttributes({ modularBlock: 'reference' });
    setReferenceBetween(false);
    setAddReferenceBlock(false);
    editor.StyleManager.addStyleTargets({
      "modular_content": `reference`,
    });
    current.removeAttributes(["modularBlockIndex"]);
    const styleContainer = document?.querySelector("#stylesMangerBlock");
    const styleSectors = styleContainer.firstElementChild.childNodes;
    const classesSelector = styleContainer.lastElementChild.children;
    for (var i = 1; i < styleSectors.length; i++) {
      styleSectors[i].classList.remove("d-block");
      styleSectors[i].classList.add("d-none");
    }
    for (var i = 0; i < classesSelector.length - 1; i++) {
      classesSelector[i].classList.remove("d-block");
      classesSelector[i].classList.add("d-none");
    }
  }

  const cancelSelection = () => {
    if (!addReferenceBlock) {
      current.getLastChild().getChildAt(1).replaceWith(`<span> Module ${modularSequence[referenceIndex]} </span>`);
      current.getLastChild().getChildAt(1).setStyle({
        "font-weight": "700",
        "letter-spacing": "0.1px"
      });
      editor.StyleManager.addStyleTargets({
        "modular_content": `approve`,
      });
      current.addAttributes({ modularBlock: 'approve' });
      current.addAttributes({ modularBlockIndex: referenceIndex });
    } else {
      const existLabel = editor?.getSelected().getLastChild();
      if (existLabel.attributes.name !== "Cell") {
        existLabel.remove();
      }
      const hasAttr = editor.getSelected().getAttributes();
      if (hasAttr.hasOwnProperty("modularBlock")) {
        editor
          .getSelected()
          .removeAttributes(["modularBlock", "modularBlockIndex"]);
      }
      const retainCell = editor?.getSelected().getLastChild();
      retainCell.setStyle({ display: "block" });
      editor.StyleManager.addStyleTargets({
        // "background-color": "#fff",
        "background-image": "none",
        border: "none",
      });
      editor.getSelected().set({
        selectable: true,
        removable: true,
        draggable: true,
        copyable: true,
        resizable: true
      });
      editor.StyleManager.addStyleTargets({
        "modular_content": `true`,
      });
      const styleContainer = document?.querySelector("#stylesMangerBlock");
      const styleSectors = styleContainer.firstElementChild.childNodes;
      const classesSelector = styleContainer.lastElementChild.children;
      for (var i = 1; i < styleSectors.length; i++) {
        styleSectors[i].classList.remove("d-none");
        styleSectors[i].classList.add("d-block");
      }
      for (var i = 0; i < classesSelector.length - 1; i++) {
        classesSelector[i].classList.remove("d-none");
        classesSelector[i].classList.add("d-block");
        classesSelector[i].classList.add("d-flex");
      }

    }

    setReferenceBetween(false);
    setAddReferenceBlock(false);

  };
  return (
    <CustomModal
      displayModal={referenceBetween}
      hideModal={() => { }}
      title={""}
      size="sm"
      dilogClassName="import-pkg-modal"
      keyboard={false}
    >
      <div className="row">
        <div className="modular-heading ">
          <img src={InfoIconRed} height={12} alt="Info Icon" />
          <span className="modular-title">Over-ride</span>
        </div>
        <div className="modular-content">
          Adding reference between 2 approved content section will remove all
          the approved content section below it.
          <div className="modular-confirmation">Are you sure?</div>
        </div>
        <div className="col-md-12 importFooter">
          <button
            className="btn close-import btn btn-primary"
            onClick={cancelSelection}
          >
            CANCEL
          </button>
          <Button className="btn import-pkg" onClick={handleReferenceBetween}>
            PROCEED
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ReferenceWarning;
